import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry, Sentry } from '../shared/lib/sentry.js';
import App from './App.jsx';
import '../shared/style.css';

initSentry({ enableReplay: true });

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>
            <h2>Something went wrong</h2>
            <p>The error has been reported. Please refresh the page.</p>
        </div>}>
            <App />
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);
